import { formatLabel } from './format-label.js';

const MAX_CLICK_TRACKING_ATTRIBUTE_LENGTH = 25;
const MAX_LABEL_LENGTH = 5;
function isMainNavId(id) {
    return id.startsWith('MainNav');
}
const getConcatClickTrackingAttributes = (label, parentAttributes)=>{
    if (!parentAttributes || !isMainNavId(parentAttributes['data-element-id'])) return undefined;
    const parentIdLength = parentAttributes['data-element-id'].length;
    const formattedLabel = `_${formatLabel(label).substring(0, MAX_LABEL_LENGTH)}`;
    const labelWithMaxLength = formattedLabel.substring(0, Math.max(MAX_CLICK_TRACKING_ATTRIBUTE_LENGTH - parentIdLength, 0));
    return {
        'data-element-id': `${parentAttributes['data-element-id']}${labelWithMaxLength}`
    };
};

export { MAX_CLICK_TRACKING_ATTRIBUTE_LENGTH, getConcatClickTrackingAttributes };
//# sourceMappingURL=get-concat-click-tracking-attributes.js.map
